import { useSelector } from 'react-redux';
import { GlobalStore } from 'types/store';
import isEqual from 'lodash/fp/isEqual';

const useStoreState = <A>(f: (store: GlobalStore) => A): A => useSelector(f, isEqual);

export default useStoreState;
